export default __webpack_public_path__ + "static/media/skill_java.6c64373d.png";